import PropTypes from 'prop-types';
import React from 'react';
export default function StatusBarUnderlay(_a) {
    var backgroundColor = _a.backgroundColor, height = _a.height;
    return React.createElement("div", { style: { backgroundColor: backgroundColor, height: height } });
}
StatusBarUnderlay.propTypes = {
    backgroundColor: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
};
